import {Select as MuiSelect, SelectProps, SelectVariants, styled} from '@mui/material';
import {ExpandMore as ExpandMoreIcon} from '@mui/icons-material';

const CustomSelect = styled(MuiSelect)(({theme}) => {

  return ({
    fontSize: 16,
    lineHeight: 1,
    color: theme.palette.text.primary,
    // background: theme.palette.inputBg,
    outline: 'none',
    borderRadius: 8,
    // padding:"0 16px",
    "& .MuiSelect-select": {
      // marginRight: "10px",
      padding: "16px 10px 8px 16px",
      lineHeight: 1,
    },
    "& .MuiSelect-select:focus": {
      // marginRight: "10px",
      backgroundColor: "transparent",
    },
    "& .MuiFilledInput-underline": {
      borderBottom: "none",
    },
    "& .Mui-focused": {
      backgroundColor: "transparent",
    }
  })
});
const CustomIcon = styled(ExpandMoreIcon)({
  width: 20,
  height: 20,
  marginTop: "4px",
  position: 'relative',
});

export default function Select<Value = unknown, Variant extends SelectVariants = 'outlined'>(props: {
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant?: Variant;
} & Omit<SelectProps<Value, Variant>, 'variant'>) {
  return <CustomSelect {...props} IconComponent={CustomIcon} disableUnderline={true} variant='standard'/>
}

export {Select}

